export default function getBackendURL() {
    if (process.env.NODE_ENV === 'development') {
       
        return 'http://localhost:8000';
    }
    return "https://backend-eddy.azurewebsites.net";
}